import React from 'react'
import { bool, func, number, string, oneOfType } from 'prop-types'
import styled from 'styled-components'

const StyledSVG = styled.svg`
  fill: ${({ fillColor }) => fillColor};
  stroke: ${({ strokeColor }) => strokeColor};
`

export function CircleCheck({
  ariaHidden,
  stroke,
  fill,
  focusable,
  height,
  title,
  width,
  ...rest
}) {
  const w = width || '1rem'
  const h = height || '1rem'

  return (
    <StyledSVG
      viewBox='0 0 20 20'
      width={w}
      height={h}
      aria-hidden={ariaHidden}
      focusable={focusable}
      fillColor={fill}
      strokeColor={stroke}
      {...rest}
    >
      {title ? <title>{title}</title> : null}
      <circle cx='10' cy='10' r='9' fill='none' strokeWidth='2' />
      <path
        d='M9.24617092,11.8275246 L7.78176168,10.3631154 C7.46652532,10.047879 6.96246015,10.0503458 6.65004072,10.3627653 C6.33544315,10.6773628 6.33777803,11.1818734 6.65039083,11.4944862 L8.8550779,13.6991733 C9.17031425,14.0144096 9.67437943,14.0119428 9.98679886,13.6995234 C10.0605759,13.6257463 10.1169229,13.5415248 10.1559257,13.4517831 L13.8864068,6.99040028 C14.1048056,6.61212257 13.9737566,6.12276171 13.5911225,5.90184781 C13.2058207,5.67939373 12.7203192,5.81012325 12.5007662,6.19040028 L9.24617092,11.8275246 Z'
        stroke='none'
      />
    </StyledSVG>
  )
}

CircleCheck.defaultProps = {
  ariaHidden: false,
  focusable: false,
  stroke: '#000',
  fill: '#000',
}

CircleCheck.propTypes = {
  ariaHidden: bool,
  stroke: oneOfType([string, func]),
  fill: oneOfType([string, func]),
  focusable: bool,
  height: number,
  title: string,
  width: number,
}
